<template>
<div class="update-adaptive-game-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc container-fluid">
              <div class="row">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles padding-left-28px">
                {{getCurrentlySelectedCourseObj.CourseTitle}}
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="close-text-font-style margin-bottom-4Perc cursor-pointer " v-on:click="udpateCloseCreateElementOverlay($event,false)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right close-image-zindex-1" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border">
                <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles padding-left-28px">
                  {{lessonObj.Title}}
                </div>    
              </div>
              <div class="row container-fluid">
                <title-audio-video-adaptive-game-bar v-if="showTitleAudioVideoOverlay" :lessonObj="getLessonObj" :ElementObj="getElementObj" @adaptiveGameRespObj="updateAdativeGameServerResp"></title-audio-video-adaptive-game-bar>
              </div>
              <div class="row container-fluid">
                <mcq-videos-post-elemement-adaptive-game-bar v-if="showStepCreationUI" :lessonObj="getLessonObj" :adaptiveGameResp="getElementObj" :overallList="getOverallList" @currentUpdatedStepList="updateCurrentStepList" :currGamePathArr="currGamePathArr"></mcq-videos-post-elemement-adaptive-game-bar>  
              </div>
              <!-- ss: start:blank row added for space-->
              <div class="row margin-bottom-15px" v-if="parseInt(currMcqList.length) === 0 || parseInt(currPostList.length) === 0 || parseInt(currVideoList.length) === 0">
                <div class="col-md-12 col-lg-12"></div> 
              </div>
              <!-- ss: end:blank row added for space-->
              <div class="row margin-bottom-2Perc container-fluid" v-if="parseInt(currMcqList.length) !== 0 && parseInt(currPostList.length) !== 0 && parseInt(currVideoList.length) !== 0">
                <div class="col-md-12 col-lg-12 border-bottom-1px padding-left-0px padding-right-0px">
                  <div class="left-border right-border container-fluid padding-top-15px padding-bottom-10px vertical-align">
                    <span v-if="showGamePath" class="col-md-3 col-lg-3 font-size-19px margin-bottom-0px text-align-left padding-Left-0px">{{currDisplayText}}</span>
                    <span v-else class="col-md-2 col-lg-2 font-size-19px margin-bottom-0px text-align-left padding-Left-0px">{{currDisplayText}}
                      
                    </span>
                    <span class="col-md-1 col-lg-1 font-size-19px padding-Left-0px padding-top-0Point6Perc text-align-left tooltip1">
                      <img :src="resetIcon" alt="imgedit" height="20" width="20" class="img-opacity cursor-pointer" @click="showResetGameAlert($event)">
                      <span class="tooltiptext1 font-size-14px">Reset Game</span>
                    </span>
                    <!-- <span class="col-md-2 col-lg-2">
                      <div class="checkbox displayInline">
                        <label><input type="checkbox" value="true" v-model="MCQIsPersonalization">Is personalization</label>
                      </div>
                    </span> -->
                  </div>
                  <adaptive-game-creation-bar v-if="parseInt(currMcqList.length) !== 0 && parseInt(currPostList.length) !== 0 && parseInt(currVideoList.length) !== 0 && (!resetGame) && (!showGamePath)" :overallList="getOverallList" :adaptiveGameResp="getElementObj" @currGamePath="updateCurrentGamePath" @finalObjToPost="updateFinalObjToPost"></adaptive-game-creation-bar>
                  <adaptive-game-show-path v-if="showGamePath" v-for="(currPath,index) in currGamePathArr" :key="index" :currPath="currPath" :currIndex="index"></adaptive-game-show-path>  
                  <div class="row" v-if="showGamePath">
                    <div class="col-md-12 col-lg-12">
                      <div class="left-border right-border height-10px"></div> 
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                 <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="udpateCloseCreateElementOverlay($event,false)" v-if="showGamePath">Close</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>
            </div>
          </div>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixResetGameString" v-bind:postfixString="postResetGameString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="resetCurrentGameFlow"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AdaptiveGameShowPath from '@/components/adaptive_game/Update-element/UpdateAdaptiveGameShowPath'
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import TitleAudioVideoAdaptiveGameBar from '@/components/adaptive_game/Update-element/UpdateTitleAudioVideoAdaptiveGameBar'
import McqVideosPostElemementAdaptiveGameBar from '@/components/adaptive_game/Update-element/UpdateMcqVideosPostElemementAdaptiveGameBar'
import AdaptiveGameCreationBar from '@/components/adaptive_game/Update-element/UpdateAdaptiveGameCreationBar'
import reset from '../../../assets/images/reset.svg'
import { elementService } from '@/server-util/element-service'
import { constants } from '@/utils/constants'
export default {
  props: ['lessonObj', 'ElementObj'],
  created: function () {
    this.getAdaptiveGameSteps()
  },
  data: function () {
    return {
      showConfirmationBox: false,
      prefixResetGameString: '',
      postResetGameString: '',
      showAlertDialog: false,
      showTitleAudioVideoOverlay: true,
      showMcqVideoPostOverlay: true,
      errorMsg: '',
      showSpinner: false,
      adaptiveGameResp: null,
      showStepCreationUI: false,
      currMcqList: [],
      currVideoList: [],
      currPostList: [],
      overallList: {},
      resetIcon: reset,
      resetGame: false,
      showGamePath: false,
      currGamePathArr: [],
      currDisplayText: 'Game Creation'
    }
  },
  name: 'update-adaptive-game-overlay',
  methods: {
    resetCurrentGameFlow (value) {
      this.showConfirmationBox = false
      if (value) {
        this.resetAllGameFlow()
      }
    },
    updateFinalObjToPost (value) {
      this.finalObj = value
    },
    updateShowConfirmationAlertFlag (value) {
      this.showConfirmationBox = value
    },
    showResetGameAlert: function (event) {
      // if (this.finalObj.GameLevels.length > 0) {
      //   this.showConfirmationBox = true
      //   this.prefixResetGameString = 'Are you sure you want to '
      //   this.postResetGameString = 'reset current game flow?'
      // } else {
      //   console.log('GameLevels >>' + this.finalObj.GameLevels.length)
      // }
      this.showConfirmationBox = true
      this.prefixResetGameString = 'Are you sure you want to '
      this.postResetGameString = 'reset current game flow?'
    },
    filterAndStoreResp: function (serverResponse) {
      this.currMcqList = []
      console.log('serverResponse: ' + serverResponse.length)
      this.currMcqList = serverResponse.filter(function (item) {
        return parseInt(item.Type) === 3
      })
      console.log('MCQ: ' + this.currMcqList.length)
      this.currVideoList = []
      this.currVideoList = serverResponse.filter(function (item) {
        return parseInt(item.Type) === 9
      })
      console.log('Video: ' + this.currVideoList.length)
      this.currPostList = []
      this.currPostList = serverResponse.filter(function (item) {
        return parseInt(item.Type) === 10
      })
      console.log('PE: ' + this.currPostList.length)
      if (this.currMcqList.length > 0 && this.currVideoList.length > 0 && this.currPostList.length > 0) {
        this.showStepCreationUI = true
      }
      this.overallList = {
        currentMcqList: this.currMcqList,
        currentVideoList: this.currVideoList,
        currentPostList: this.currPostList
      }
      console.log('this.currMcqList.length: ' + this.currMcqList.length + ' this.currVideoList.length >>> ' + this.currVideoList.length + ' this.currPostList.length >>> ' + this.currPostList.length)
    },
    getAdaptiveGameSteps: function () {
      var _this = this
      var storeObj = this.$store
      var serverResponse = null
      if (_this.getElementObj !== undefined && _this.getElementObj !== '' && _this.getElementObj !== null) {
        // console.log(JSON.stringify(this.getElementObj))
        _this.$store.state.isLoading = true
        elementService
          .getAdaptiveGameStepElements(storeObj.state.access_token, _this.getElementObj.BonusModuleId)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                serverResponse = responseObj.data
                // console.log('Update Adaptive Game Resp >> ' + JSON.stringify(serverResponse))
                _this.filterAndStoreResp(serverResponse)
                _this.showNextBtn = false
                _this.$store.state.isLoading = false
                _this.getAdaptiveGamePathFromServer()
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              _this.showAlertDialog = true
              _this.$store.state.isLoading = false
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected Element Object is NULL hence declined GET ADAPTIVE GAME SUB-STEP(s)'
        )
      }
    },
    updateCurrentGamePath (value) {
      if (value.length !== 0) {
        this.showGamePath = true
        this.currGamePathArr = value
        this.currDisplayText = 'Learning Game Path(s):'
      } else {
        this.showGamePath = false
        this.showAlertDialog = true
        this.errorMsg = 'No paths found'
        this.currDisplayText = 'Game Creation'
      }
    },
    resetAllGameFlow: function () {
      if (this.currGamePathArr.length > 0) {
        this.resetCurrentAdaptiveGamePath()
      } else {
        this.reLoadAssociationComponent()
      }
    },
    reLoadAssociationComponent: function () {
      var _this = this
      _this.resetGame = true
      setTimeout(function () {
        _this.resetGame = false
      }, 150)
    },
    updateAdativeGameServerResp (value) {
      this.adaptiveGameResp = value.serverResp
      this.showStepCreationUI = value.showStepCreationUI
    },
    udpateCloseCreateElementOverlay: function (event, flagToUpdate) {
      this.$emit('refreshElementList', true)
      this.$emit('closeUpdateAdaptiveGameOverlay', flagToUpdate)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateCurrentStepList (value) {
      this.currMcqList = value.currentMcqList
      this.currVideoList = value.currentVideoList
      this.currPostList = value.currentPostList
      this.overallList = {
        currentMcqList: this.currMcqList,
        currentVideoList: this.currVideoList,
        currentPostList: this.currPostList
      }
    },
    getAdaptiveGamePathFromServer: function () {
      var _this = this
      var storeObj = this.$store
      var serverResponse = null
      if (_this.getElementObj !== undefined && _this.getElementObj !== '' && _this.getElementObj !== null) {
        _this.$store.state.isLoading = true
        elementService
          .getAdaptiveGamePath(storeObj.state.access_token, _this.getElementObj.ElementId)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                serverResponse = responseObj.data
                console.log('getAdaptiveGamePathFromServer >> ' + JSON.stringify(serverResponse))
                _this.showStepCreationUI = true
                if (serverResponse !== undefined && serverResponse !== null && serverResponse !== '' && serverResponse.length !== 0) {
                  _this.currGamePathArr = serverResponse
                  _this.showGamePath = true
                  _this.currDisplayText = 'Learning Game Path(s):'
                } else {
                  _this.showGamePath = false
                  _this.currDisplayText = 'Game Creation'
                }
                _this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              _this.showAlertDialog = true
              _this.$store.state.isLoading = false
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected Element Object is NULL hence declined GET ADAPTIVE GAME SUB-STEP(s)'
        )
      }
    },
    resetCurrentAdaptiveGamePath: function () {
      var _this = this
      var storeObj = this.$store
      var serverResponse = null
      if (_this.getElementObj !== undefined && _this.getElementObj !== '' && _this.getElementObj !== null) {
        _this.$store.state.isLoading = true
        elementService
          .resetAdaptiveGamePath(storeObj.state.access_token, _this.getElementObj.ElementId)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                serverResponse = responseObj.data
                _this.reLoadAssociationComponent()
                console.log('resetCurrentAdaptiveGamePath >> ' + JSON.stringify(serverResponse))
                _this.showGamePath = false
                _this.currGamePathArr = []
                _this.currDisplayText = 'Game Creation'
                _this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              _this.showAlertDialog = true
              _this.$store.state.isLoading = false
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected Element Object is NULL hence declined GET ADAPTIVE GAME SUB-STEP(s)'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay,
    'title-audio-video-adaptive-game-bar': TitleAudioVideoAdaptiveGameBar,
    'mcq-videos-post-elemement-adaptive-game-bar': McqVideosPostElemementAdaptiveGameBar,
    'adaptive-game-creation-bar': AdaptiveGameCreationBar,
    'adaptive-game-show-path': AdaptiveGameShowPath
  },
  computed: {
    getAdaptiveGamePath: {
      get: function () {
        return this.currGamePathArr
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getOverallList: {
      get: function () {
        // console.log('updateCurrentStepList >>>> ' + JSON.stringify(this.overallList))
        return this.overallList
      }
    },
    getElementObj: {
      get: function () {
        return this.ElementObj
      }
    },
    getLessonObj: {
      get: function () {
        return this.lessonObj
      }
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-4Perc
{
	margin-bottom: 4%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 3% !important;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.dotted-border {
  border-bottom: 1px dotted;
}
.padding-bottom-0Px {
  padding-bottom:0Px;
}
.font-size-19px {
  font-size:19px;
}
.padding-top-15px {
 padding-top:15px; 
}
.right-border {
  border-right: 1px solid #aaa;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.margin-left-1Point6Perc {
    margin-left: 1.6%;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.padding-left-20px {
  padding-left:20px;
}
.padding-left-28px {
  padding-left:28px;
}
.margin-bottom-15px {
  margin-bottom:15px;
}
.border-bottom-1px {
  border-bottom: 1px solid #aaa; 
}
.padding-left-0px {
  padding-left:0px;
}
.padding-right-0px {
  padding-right:0px;
}
.padding-bottom-10px {
  padding-bottom: 10px;
}
.height-10px {
  height: 10px;
}

.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 90px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 107%;
    left: 35%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.font-size-14px {
  font-size: 14px;
}
.displayInline {
  display: inline;
}
.textAlignCenter {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateAdaptiveGameOverlay.vue